module.exports = __webpack_public_path__ + "img/PL00193.4536e71d.png";